<template>
    <router-view />
</template>

<script lang="ts">
import { Options } from "vue-class-component"
import {useRouter} from "vue-router";
import BaseComponent from "@/components/calculator/base-components/BaseComponent";


@Options({
  components: {
  }
})
export default class BasisModule extends BaseComponent {
  router = useRouter()

  beforeMount() {
    this.setDocumentTitleByKey('basismodule.overview.title')
  }

  async mounted() {
    this.eventHub.emit('setBasisModule', true)
  }

  async unmounted() {
    this.eventHub.emit('setBasisModule', false)
  }

}
</script>